"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDateDTOFromDate = createDateDTOFromDate;
exports.serializeMonthDTO = serializeMonthDTO;
exports.deserializeMonthDTO = deserializeMonthDTO;
function createDateDTOFromDate(date) {
    return {
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate(),
    };
}
function serializeMonthDTO(year, month) {
    const m = month + 1;
    return year + "-" + (m > 9 ? m : `0${m}`);
}
function deserializeMonthDTO(key) {
    if (key.length !== 7) {
        throw new Error("invalid month dto key");
    }
    return {
        year: parseInt(key.substring(0, 4)),
        month: parseInt(key.substring(5, 7)),
    };
}
//# sourceMappingURL=DateDTO.js.map